export function init() {
	const detailsList = document.querySelectorAll<HTMLDetailsElement>('details.wp-block-details.is-style-search-toggle, details.wp-block-details.is-style-language-toggle');

	detailsList.forEach(function(details) {
		details.addEventListener('toggle', function(event) {
			if (!(event.target as HTMLDetailsElement).open) {
				return;
			}
			details.querySelector<HTMLElement>('input, a, button')?.focus();
		})
	});

	document.addEventListener('click', function(event) {
		if (!Array.from(detailsList).some(f => f.contains(event.target as HTMLDetailsElement))) {
			detailsList.forEach(f => f.removeAttribute('open'));
		} else {
			detailsList.forEach(f => !f.contains(event.target as HTMLDetailsElement) ? f.removeAttribute('open') : '');
		}
	})
}
